import { history } from '../../browserHistory';

import { LocalizedStrings, GlobalStrings } from '@src/utils/localizedStrings';
import { IAlert } from '@src/types/alert';
import { Pathname } from '@src/types/Browsing';
import { getDefaultStore } from 'jotai';
import { enqueueAlertAtom, AlertEventCreation } from '@src/fragments/Alerting/alertAtom';

const jotaiStore = getDefaultStore();

const routeParamsCache: Map<string, string> = new Map();

export function loadTranslation<T extends Record<string, unknown>>(translation: GlobalStrings<T>) {
  return LocalizedStrings<T>(translation);
}

export function setRoute(route: Pathname) {
  const targetRoute = new URL(`http://a${route}`);

  const currentRoute = window.location.pathname + window.location.search;
  if (route === currentRoute) {
    return;
  }

  const { pathname } = targetRoute;
  let { search }: { search: string | undefined } = targetRoute;

  routeParamsCache.set(window.location.pathname, window.location.search);
  if (currentRoute.indexOf(Pathname.discover) === -1 && route.indexOf(Pathname.discover) > -1) {
    // we're navigating from another page to the discover page
    if (!search) {
      search = routeParamsCache.get(pathname);
    }
  }

  history.push(pathname + (search ?? ''));
}

const severityMap: Record<IAlert['type'], AlertEventCreation['severity']> = {
  danger: 'error',
  success: 'success',
  warning: 'warning',
};

export function addAlert(alert: Omit<IAlert, 'id'>) {
  const mappedAlert: AlertEventCreation = {
    text: window.T(alert.text),
    severity: severityMap[alert.type] ?? 'error',
  };
  jotaiStore.set(enqueueAlertAtom, mappedAlert);
}

export function notLogged() {
  // The user session has probably expired
  addAlert({ text: 'common.error.notlogged', type: 'danger' });
  history.push('/login');
}

export function notAuthorized() {
  addAlert({ text: 'common.error.auth', type: 'danger' });
}

export function triggerResize() {
  window.dispatchEvent(new Event('resize'));
}
